import { renderRandomPlotlyChart } from './plotlygraphics.js';

// ОПИСЫВАЕМ МАССИВ ВСЕХ ГРАФИКОВ И ИХ ОПЦИЙ ОДИН РАЗ:
const plotlyCharts = [
    { id: 'plot1', options: {} },
    { id: 'plot2', options: { type: 'pie' } },
    { id: 'plot3', options: { n: 30, type: 'bar' } },
    { id: 'plot4', options: {} },
    { id: 'plot5', options: {} },
    { id: 'plot6', options: {} },
    { id: 'plot7', options: {} },
    { id: 'plot8', options: {} },
    { id: 'plot9', options: {} },
    { id: 'plot10', options: {} },
];

// ГЛОБАЛЬНАЯ ФУНКЦИЯ ДЛЯ ОТРИСОВКИ ВСЕХ ГРАФИКОВ:
function renderAllPlotlyCharts() {
    plotlyCharts.forEach(({ id, options }) => {
        renderRandomPlotlyChart(id, options);
    });
}

// 1. ОТРИСОВЫВАЕМ ПРИ ЗАГРУЗКЕ СТРАНИЦЫ
document.addEventListener('DOMContentLoaded', renderAllPlotlyCharts);

// 2. ПЕРЕРИСОВЫВАЕМ ПРИ СМЕНЕ ТЕМЫ
window.addEventListener('themechanged', renderAllPlotlyCharts);
